import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

// Import translations - English
import enCommon from '@/locales/en/common.json'
import enAuth from '@/locales/en/auth.json'
import enAgents from '@/locales/en/agents.json'
import enKnowledge from '@/locales/en/knowledge.json'
import enTools from '@/locales/en/tools.json'
import enValidation from '@/locales/en/validation.json'
import enAdmin from '@/locales/en/admin.json'
import enLanding from '@/locales/en/landing.json'
import enOrganizations from '@/locales/en/organizations.json'
import enChat from '@/locales/en/chat.json'
import enWorkflows from '@/locales/en/workflows.json'

// Import translations - Portuguese (Brazil)
import ptBRCommon from '@/locales/pt-BR/common.json'
import ptBRAuth from '@/locales/pt-BR/auth.json'
import ptBRAgents from '@/locales/pt-BR/agents.json'
import ptBRKnowledge from '@/locales/pt-BR/knowledge.json'
import ptBRTools from '@/locales/pt-BR/tools.json'
import ptBRValidation from '@/locales/pt-BR/validation.json'
import ptBRAdmin from '@/locales/pt-BR/admin.json'
import ptBRLanding from '@/locales/pt-BR/landing.json'
import ptBROrganizations from '@/locales/pt-BR/organizations.json'
import ptBRChat from '@/locales/pt-BR/chat.json'
import ptBRWorkflows from '@/locales/pt-BR/workflows.json'

// Import translations - Spanish
import esCommon from '@/locales/es/common.json'
import esAuth from '@/locales/es/auth.json'
import esAgents from '@/locales/es/agents.json'
import esKnowledge from '@/locales/es/knowledge.json'
import esTools from '@/locales/es/tools.json'
import esValidation from '@/locales/es/validation.json'
import esAdmin from '@/locales/es/admin.json'
import esLanding from '@/locales/es/landing.json'
import esOrganizations from '@/locales/es/organizations.json'
import esChat from '@/locales/es/chat.json'
import esWorkflows from '@/locales/es/workflows.json'

const resources = {
  en: {
    common: enCommon,
    auth: enAuth,
    agents: enAgents,
    knowledge: enKnowledge,
    tools: enTools,
    validation: enValidation,
    admin: enAdmin,
    landing: enLanding,
    organizations: enOrganizations,
    chat: enChat,
    workflows: enWorkflows,
  },
  'pt-BR': {
    common: ptBRCommon,
    auth: ptBRAuth,
    agents: ptBRAgents,
    knowledge: ptBRKnowledge,
    tools: ptBRTools,
    validation: ptBRValidation,
    admin: ptBRAdmin,
    landing: ptBRLanding,
    organizations: ptBROrganizations,
    chat: ptBRChat,
    workflows: ptBRWorkflows,
  },
  es: {
    common: esCommon,
    auth: esAuth,
    agents: esAgents,
    knowledge: esKnowledge,
    tools: esTools,
    validation: esValidation,
    admin: esAdmin,
    landing: esLanding,
    organizations: esOrganizations,
    chat: esChat,
    workflows: esWorkflows,
  },
}

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: 'pt-BR', // Default language for this application
    fallbackLng: 'pt-BR',
    defaultNS: 'common',
    ns: ['common', 'auth', 'agents', 'knowledge', 'tools', 'validation', 'admin', 'landing', 'organizations', 'chat', 'workflows'],
    interpolation: {
      escapeValue: false, // React already escapes
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
  })

export default i18n
